import type { Affiliate, AffiliateStatus } from '../types'

export function mapFromAffiliatesRow(row: any): Affiliate {
  const status: AffiliateStatus = row?.active === false ? 'inativo' : 'ativo'
  return {
    id: row.user_id,
    name: row.full_name ?? row.name ?? null,
    email: row.email ?? null,
    code: row.code ?? null,
    created_at: row.created_at ?? null,
    status,
  }
}

export function mapFromProfilesRow(row: any): Affiliate {
  const status: AffiliateStatus = 'ativo'
  return {
    id: row.id,
    name: row.full_name ?? null,
    email: row.email ?? null,
    code: null,
    created_at: row.created_at ?? null,
    status,
  }
}

